import { z } from "zod";
import {
  DTOPortalSettingsGetResponse,
  DTOPortalSettingsUpdatePayload,
  DTOUserWorkspaceMembershipsResponse,
  DTOWorkspaceCreateInput,
  DTOWorkspaceResponse,
} from "../../dto";
import { DTOTransferOwnershipPayload } from "../../payloads";
import { RequestExecutor } from "../../transport/request-executor";
import { WorkspaceChatThreadsEndpoint } from "./chat-threads";
import { WorkspaceIntegrationsEndpoint } from "./integrations";
import { WorkspaceInvitationsEndpoint } from "./invites";
import { WorkspaceMembersEndpoint } from "./members";
import { WorkspaceNpmRegistryEndpoint } from "./npm-register";

// TODO Response types
export class WorkspacesEndpoint {
  public members: WorkspaceMembersEndpoint;
  public invitations: WorkspaceInvitationsEndpoint;
  public npmRegistry: WorkspaceNpmRegistryEndpoint;
  public chatThreads: WorkspaceChatThreadsEndpoint;
  integrations: WorkspaceIntegrationsEndpoint;

  constructor(private readonly requestExecutor: RequestExecutor) {
    this.members = new WorkspaceMembersEndpoint(requestExecutor);
    this.invitations = new WorkspaceInvitationsEndpoint(requestExecutor);
    this.integrations = new WorkspaceIntegrationsEndpoint(requestExecutor);
    this.npmRegistry = new WorkspaceNpmRegistryEndpoint(requestExecutor);
    this.chatThreads = new WorkspaceChatThreadsEndpoint(requestExecutor);
  }

  create(body: DTOWorkspaceCreateInput) {
    return this.requestExecutor.json("/workspaces", DTOWorkspaceResponse, {
      method: "POST",
      body: {
        ...body,
        product: "free",
        priceId: "yearly",
      },
    });
  }

  list() {
    return this.requestExecutor.json(`/workspaces`, DTOUserWorkspaceMembershipsResponse, { method: "GET" });
  }

  get(workspaceId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}`, DTOWorkspaceResponse, { method: "GET" });
  }

  delete(workspaceId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}`, z.any(), { method: "DELETE" });
  }

  subscription(workspaceId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/subscription`, z.any(), { method: "GET" });
  }

  getPortalSettings(workspaceId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/portal/settings`, DTOPortalSettingsGetResponse, {
      method: "GET",
    });
  }

  updatePortalSettings(workspaceId: string, body: DTOPortalSettingsUpdatePayload) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/portal/settings`, DTOPortalSettingsGetResponse, {
      method: "PUT",
      body,
    });
  }

  transferOwnership(workspaceId: string, body: DTOTransferOwnershipPayload) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/ownership`, DTOWorkspaceResponse, {
      method: "PUT",
      body,
    });
  }
}
